import React, { useRef, useState, useEffect } from 'react';
import TextArea from '../components/ui/TextArea';
import TextInput from '../components/ui/TextInput';
import { BsFillTelephoneFill } from "react-icons/bs";
import { useTranslation } from 'react-i18next';
import emailjs from "emailjs-com";
import isValidEmail from "../utils/isValidEmail";
import { toast } from 'react-toastify';

const Contact = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    const { t } = useTranslation();

    const formRef = useRef(null);
    const emailInputRef = useRef(null);
    const [loading, setLoading] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();
        const email = emailInputRef.current.value;
        if (!isValidEmail(email)) {
            return toast.error("Invalid email address!", {
                position: "bottom-left",
            });
        }

        setLoading(true);
        emailjs
            .sendForm(
                "service_3dv2a5s", // email-js service-Id (here use google)
                "template_678i29x", // email-js template Id
                e.target,
                "qVW1b6vedLBBSWBaJ" // email-js user Id
            )
            .then(
                (result) => {
                    setLoading(false);
                    formRef?.current?.reset();
                    toast.success("Mail send successfully", {
                        position: "bottom-left",
                    });
                },
                (error) => {
                    setLoading(false);
                    toast.error(error.text, {
                        position: "bottom-left",
                    });
                }
            );
    };

    return (
        <div className='bg-gray-200'>
            {/* <div className=' p-2 xl:p-5 translate-x-4 md:translate-x-0'>
                hello
            </div> */}
            <div className='container mx-auto py-5'>
                <div className='bg-white p-4 grid grid-cols-2 shadow-sm gap-3 pb-5'>
                    <div className='md:col-span-1 col-span-2'>
                        <h3 className='text-3xl font-normal font-poppins py-4'>{t('contact.hadline1')}</h3>
                        <hr className='w-20 h-0.5 rounded mb-4 bg-bnd-1' />
                        <p className='text-sm text-gray-600 pt-3'>{t('contact.text.des')}</p>
                        <div className='py-4 flex gap-2 mt-2'>
                            <div className='grid content-center'>
                                <BsFillTelephoneFill className='text-xl text-bnd-1' />
                            </div>
                            <h4 className='text-bnd-1 text-2xl font-poppins'>+88 01841-282920</h4>
                        </div>
                    </div>
                    <div className='md:col-span-1 col-span-2'>
                        <h3 className='text-3xl font-normal font-poppins py-4'>{t('contact.hadline1')}</h3>
                        <hr className='w-20 h-0.5 rounded mb-4 bg-bnd-1' />
                        <div className='pt-3'>
                            <form
                                ref={formRef}
                                onSubmit={sendEmail}
                            >
                                <TextInput className="my-1 border border-gray-400 w-full py-2.5 px-3 focus:outline-none font-poppins" placeholder={`${t('contact.input.name')}`} name="name" />
                                <TextInput className="my-1 border border-gray-400 w-full py-2.5 px-3 focus:outline-none font-poppins" placeholder={`${t('contact.input.mobile')}`} name="mobile" />
                                <input
                                    type="text"
                                    placeholder={`${t('contact.input.email')}`} 
                                    name="email" ref={emailInputRef} 
                                    className="rounded h-9 focus:outline-offset-2  outline-blue-500/50 text-gray-600 my-1 border border-gray-400 w-full py-3 px-3 focus:outline-none font-poppins"
                                    
                                />
                                {/* <TextInput className="my-1 border border-gray-400 w-full py-2.5 px-3 focus:outline-none font-poppins" placeholder={`${t('contact.input.email')}`} name="email" ref={emailInputRef} /> */}
                                <TextArea className="my-1 border border-gray-400 w-full py-2.5 px-3 rounded-none focus:outline-none font-poppins" placeholder={`${t('contact.input.massage')}`} name="massage" />
                                <button className='mb-5 mt-1 focus:outline-none py-1 px-3 uppercase text-white bg-bnd-1'>{loading ? "Loading..." : t('contact.input.btn')}</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;